(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("katex"), require("@wangeditor/editor"));
	else if(typeof define === 'function' && define.amd)
		define(["katex", "@wangeditor/editor"], factory);
	else if(typeof exports === 'object')
		exports["WangEditorPluginFormula"] = factory(require("katex"), require("@wangeditor/editor"));
	else
		root["WangEditorPluginFormula"] = factory(root["katex"], root["wangEditor"]);
})(self, function(__WEBPACK_EXTERNAL_MODULE__771__, __WEBPACK_EXTERNAL_MODULE__857__) {
return 